import { StatusColor } from "@homesusa/core";

export enum UserStatus {
  Active = "active",
  Archived = "archived",
  AwaitingApproval = "awaitingApproval"
}

export const UserStatusLabel = new Map<UserStatus, string>([
  [UserStatus.Active, "Active"],
  [UserStatus.Archived, "Archived"],
  [UserStatus.AwaitingApproval, "Awaiting approval"]
]);

export const UserStatusColor: Record<UserStatus, StatusColor> = {
  [UserStatus.Active]: StatusColor.Green,
  [UserStatus.Archived]: StatusColor.Red,
  [UserStatus.AwaitingApproval]: StatusColor.Orange
};
